import styled from 'styled-components'

const H3 = styled.h3`
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  font-size: 1.3em;
`
export default H3
